/* eslint-disable react-hooks/rules-of-hooks */
import { TextField } from "@lyfegen-platform/react-common";
import { parseDate } from "@lyfegen-platform/utils";
import { Box } from "@material-ui/core";
import { addDays, format, startOfDay } from "date-fns";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import useStyles from "../containers/data/forms/forms-styles";
import { getFormDatesByCases } from "../hooks/useSiblingFormDates";
import { FlexContext } from "../models/flexible/flex-context";
import { FlexControlProps } from "../models/flexible/flex-field-controller";
import { getMinAssessmentDate, getMinDateMessage } from "../utils/get-min-assessment-date";
import renderDateMessage from "../utils/render-date-message";
import { TrFun } from "../utils/types";
import { GeneralFieldController } from "./general-field-controller";

function RenderLastPrescription(props: { context: FlexContext }) {
	const { maxPrescriptionDate } = getFormDatesByCases(props.context.cases, props.context.flexEntity?.createdOn);
	const styles = useStyles();
	const { t } = useTranslation();

	return (
		<Box mt={5}>
			<TextField
				variant="outlined"
				disabled
				fullWidth
				InputProps={{
					className: styles.disabledInput,
					classes: { notchedOutline: styles.disableInputOutline },
				}}
				label={t("lastPrescriptionDate")}
				defaultValue={maxPrescriptionDate ? format(parseDate(maxPrescriptionDate), "dd.MM.yyyy") : t("will-be-determined-auto")}
			/>
		</Box>
	);
}

export class BenefitAssessmentDateFieldController extends GeneralFieldController {
	override createValidationRule(initialData: unknown, translate: TrFun): Yup.AnySchema {
		const dates = getFormDatesByCases(this.parent.context.cases, this.parent.context.flexEntity?.createdOn);

		return (this.createFieldValidationRuleByDataType(translate) as Yup.DateSchema)
			.required(() => renderDateMessage(this.schema.attribute.identifier, translate))
			.max(new Date(), translate("cannot-be-greater-than-today"))
			.min(
				getMinAssessmentDate(dates.maxCBAssessmentDate, dates.responseAssessmentDate, dates.startingFormAssessmentDate),
				getMinDateMessage(translate, dates.maxCBAssessmentDate, dates.responseAssessmentDate, dates.startingFormAssessmentDate)
			);
	}

	override useControlProps(): FlexControlProps {
		const today = startOfDay(new Date());
		const { maxCBAssessmentDate, responseAssessmentDate, startingFormAssessmentDate } = getFormDatesByCases(
			this.parent.context.cases,
			this.parent.context.flexEntity?.createdOn
		);
		const minAssessmentDate = addDays(getMinAssessmentDate(maxCBAssessmentDate, responseAssessmentDate, startingFormAssessmentDate), 1);

		return {
			maxDate: today,
			minDate: minAssessmentDate,
		};
	}

	renderAfterContent(): React.ReactElement {
		return <RenderLastPrescription context={this.parent.context} />;
	}
}
